module.exports = __webpack_public_path__ + "img/img_nrgl_ksp@2x.d1eefde7.png";